module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold_Web.6969e4b.woff";